<main class="main-container">
    <form [formGroup]="orderDetailsForm" (ngSubmit)="onSubmit()">
        <div class="content-padding">

            <div class="row paragraph mt-3">
                <div class="col-12">
                    <h2 class="step-heading">Step 1: Order Details</h2>
                </div>

            </div>

            <div class="row paragraph mt-4">
                <div class="col-12 pb-2">
                    <span style="background-color: #d3d3d3;">Download the Credit Schedule and Access Offer <a href="https://propertymatrix.blob.core.windows.net/propertymatrix-prod/PropertyMatrixDocuments/Service_Schedule_Access_structure%20.pdf" target="_blank" rel="noopener noreferrer" class="link">here</a>.</span>
                </div>
                <div class="col-12">
                    <label class="bold mb-2">
                        <span class="burnt-red">|</span>
                        Select Your Report
                    </label>
                </div>
                <div class="col-12 mt-2">
                    <mat-radio-group formControlName="reportLevel" (change)="onReportLevelChange($event)">

                        <div class="report-option">
                            <mat-radio-button [value]="1">
                                <span class="report-level-title">Level 1 – Pre-Screening Assessment</span>
                            </mat-radio-button>
                            <p class="report-description">
                                Initial screening of development potential and value-add opportunities.
                                View sample report <a href="https://propertymatrix.blob.core.windows.net/propertymatrix-prod/PropertyMatrixDocuments/Sample_Report_CM.pdf" target="_blank" rel="noopener noreferrer" class="link">here</a>
                            </p>
                        </div>

                        <div class="report-option mt-3">
                            <mat-radio-button [value]="2">
                                <span class="report-level-title">Level 2 – Full Potential &amp; Risk Assessment</span>
                            </mat-radio-button>
                            <p class="report-description">
                                Comprehensive analysis of development potential and risk factors to accelerate serious offers.
                                View sample report <a href="https://propertymatrix.blob.core.windows.net/propertymatrix-prod/PropertyMatrixDocuments/Print_Report_CM.pdf" target="_blank" rel="noopener noreferrer" class="link">here</a>
                            </p>
                        </div>

                    </mat-radio-group>
                </div>
            </div>

            <div class="row paragraph mt-4">
                <div class="col-12">
                    <label class="bold mb-2">
                        <span class="burnt-red">|</span>
                        Confirm Eligibility
                    </label>
                </div>
                <div class="col-12 mt-1">
                    <p class="paragraph">Please confirm the following before proceeding:</p>
                </div>

                <div class="col-12 mt-2" *ngIf="isLevel1">
                    <div class="eligibility-row">
                        <mat-checkbox formControlName="eligibilityLevel1Price" class="eligibility-checkbox">
                            The asking price is R4 million or less
                        </mat-checkbox>
                    </div>
                </div>

                <div class="col-12 mt-2">
                    <div class="eligibility-row">
                        <mat-checkbox formControlName="eligibilityDevelopmentPotential" class="eligibility-checkbox">
                            The property offers development or value-add potential; no single residential without potential
                            e.g. single flat, sectional unit, apartment or townhouse
                        </mat-checkbox>
                    </div>
                    <mat-error
                        *ngIf="orderDetailsForm.get('eligibilityDevelopmentPotential')?.invalid &&
                   orderDetailsForm.get('eligibilityDevelopmentPotential')?.touched"
                        class="paragraph mt-1">
                        Please confirm the property offers development or value-add potential.
                    </mat-error>
                </div>
            </div>

            <div class="row paragraph mt-4">
                <div class="col-12">
                    <label class="bold mb-2">
                        <span class="burnt-red">|</span>
                        Select your Professional Fee option
                    </label>
                </div>
                <div class="col-12 mt-2">
                    <mat-radio-group formControlName="feeOption" (change)="onFeeOptionChange($event)">

                        <div class="fee-option">
                            <mat-radio-button value="direct">
                                <span class="fee-option-title">Direct Option</span>
                            </mat-radio-button>
                            <p class="fee-option-description">
                                Credits are allocated immediately to prepare and publish the report.
                            </p>
                        </div>

                        <div class="fee-option mt-3">
                            <mat-radio-button value="success">
                                <span class="fee-option-title">Success-Based Option</span>
                            </mat-radio-button>
                            <p class="fee-option-description">
                                Property Matrix carries the upfront cost. The professional fee becomes payable only upon a successful sale.
                            </p>
                        </div>

                    </mat-radio-group>
                </div>
            </div>

        </div>

        <div class="row paragraph mt-5">
            <div class="text-center">
                <button class="button" type="submit" [disabled]="orderDetailsForm.invalid">Submit</button>
            </div>
        </div>
    </form>
</main>
